<template>
	<footer>
		<div class="footer">
			<div class="footer__container">
				<div class="footer__wrapper">
					<div class="footer__logo">
						<router-link :to="{ path: '/' }">
							<img :src="logo" alt="" />
						</router-link>
					</div>

					<div class="footer__menu menu">
						<nav class="menu__body">
							<ul class="menu__list">
								<li class="menu-item">
									<router-link :to="{ path: '/', hash: '#services' }">
										Услуги
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{ path: '/', hash: '#case' }">
										Кейсы
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{ path: '/', hash: '#thanks' }">
										Клиенты
									</router-link>
								</li>
								<li class="menu-item">
									<router-link :to="{ path: '/', hash: '#team' }">
										Команда
									</router-link>
								</li>
							</ul>
						</nav>
					</div>

					<div class="footer__links">
						<ul>
							<li>
								<a :href="privacyPolicy" rel="nofollow noopener" target="_blank"
									>Политика конфиденциальности</a
								>
							</li>
						</ul>
					</div>

					<a class="footer__phone" :href="`tel:${cleanPhoneNumber}`">
						{{ phoneNumber }}
					</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'

import logo from '@/assets/img/header/logo.svg'

import { getPdfs } from '@/api/docs'
import { getMain } from '@/api/page-main'

const privacyPolicy = ref('')
const phoneNumber = ref('')

onMounted(async () => {
	try {
		const pdfs = await getPdfs()
		privacyPolicy.value = pdfs.data.privacy_policy || ''

		const { data } = await getMain()
		phoneNumber.value = data.contacts.phone_number
	} catch (err) {
		console.warn('Ошибка при загрузке данных:', err)
	}
})
const cleanPhoneNumber = computed(() => phoneNumber.value.replace(/\D/g, '').replace(/^8/, '7'))
</script>

<style scoped lang="scss">
.footer {
	padding: 4.6rem 0;
	background: #2b2e2f;

	@media (max-width: 991.98px) {
		padding: 4rem 0 2rem;
	}

	// .footer__container
	&__container {
	}

	// .footer__wrapper
	&__wrapper {
		display: flex;

		@media (max-width: 991.98px) {
			flex-direction: column;
		}
	}

	// .footer__logo
	&__logo {
		width: 100%;
		max-width: 16.8rem;

		@media (max-width: 991.98px) {
			order: 1;
		}

		a {
			display: block;
			width: 100%;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	// .footer__menu
	&__menu {
		margin-left: 8.6rem;

		@media (max-width: 991.98px) {
			margin-left: 0;
			margin-top: 2rem;
			order: 2;
		}

		.menu {
			// .menu__body
			&__body {
			}

			// .menu__list
			&__list {
				@media (min-width: 991.98px) {
					display: flex;
					align-items: center;
				}

				li {
					&:not(:last-child) {
						@media (min-width: 991.98px) {
							margin-right: 3.3rem;
						}

						@media (max-width: 991.98px) {
							border-bottom: 1px solid rgba(255, 255, 255, 0.2);
						}
					}

					a {
						display: block;
						font-weight: 400;
						font-size: 2.2rem;
						// line-height: 2.4rem;
						line-height: 108%;
						transition: color 0.3s ease 0s;

						@media (max-width: 991.98px) {
							padding: 2rem 0;
							font-size: 1.6rem;
						}

						@media (any-hover: hover) {
							&:hover {
								color: var(--primary-color);
							}
						}
					}
				}
			}
		}
	}

	// .footer__links
	&__links {
		margin-left: 8.6rem;
		margin-right: 8.6rem;

		@media (max-width: 991.98px) {
			margin: 0;
			margin-right: 2rem;
			order: 4;
		}

		ul {
			@media (min-width: 991.98px) {
				display: flex;
				align-items: center;
			}

			li {
				&:not(:last-child) {
					@media (min-width: 991.98px) {
						margin-right: 3.3rem;
					}

					@media (max-width: 991.98px) {
						border-bottom: 1px solid rgba(255, 255, 255, 0.2);
					}
				}

				a {
					display: block;
					font-weight: 400;
					font-size: 2.2rem;
					// line-height: 2.4rem;
					line-height: 108%;
					color: rgba(255, 255, 255, 0.6);
					transition: color 0.3s ease 0s;

					@media (max-width: 991.98px) {
						padding: 2rem 0;
						font-size: 1.6rem;
					}

					@media (any-hover: hover) {
						&:hover {
							color: var(--primary-color);
						}
					}
				}
			}
		}
	}

	// .footer__phone
	&__phone {
		margin: 0px 0px 0px auto;
		color: #f27699;
		font-weight: 400;
		font-size: 2.2rem;
		// line-height: 2.4rem;
		line-height: 108%;
		transition: color 0.3s ease 0s;

		@media (max-width: 991.98px) {
			margin: 2rem 0 0;
			order: 3;
			font-size: 2.2rem;
		}

		@media (any-hover: hover) {
			&:hover {
				color: #fff;
			}
		}
	}
}
</style>
